import styled from 'styled-components';
import Input from '../../components/Input';
import Button from '../../components/Button';

const StyledBooking = styled.section`
  position: relative;
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
    margin:20px 0px 0px 0px;
  };
  .padding-20{
    padding:20px;
  }
  hr{
      background:rgba(34,36,38,.15);
      height:1px;
      border:none;
      margin-top:30px;
      width:100%;
    }
  .tabs{
      margin:0px;
      padding:0px;
      list-style:none;
      background:${(props) => props.theme.lightGray};
      li{
        display:inline-block;
        a{
          font-size: 14px;
          font-weight: 600;
          color: #505050;
          display:inline-block;
          text-decoration:none;
          padding:10px 20px;
          &.active{
            background:${(props) => props.theme.whiteColor};
            color: ${(props) => props.theme.secondaryColor};
            font-weight:bold;
          }
        }
      }
    }
    h2{
      font-size:16px;
      font-weight:bold;
      color: ${(props) => props.theme.secondaryColor};
    }
    .value{
      margin:0px;
      padding:0px;
      list-style:none;
      li{
        display:inline-block;
        strong{
          display:inline-block;
          text-decoration:none;
          padding:6px 15px;
          border:${(props) => props.theme.lightGray} solid 1px;
          margin:0px 10px 10px 0px;
          color: ${(props) => props.theme.blackColor};
          font-weight: normal;
          cursor: pointer;
          border-radius:5px;
          &:hover{
            border:${(props) => props.theme.primaryColor} solid 1px;
          }
          &.active{
            border:${(props) => props.theme.primaryColor} solid 1px;
            color:${(props) => props.theme.primaryColor};
            background: rgb(237 59 65 / 15%);
            font-weight: bold;
          }
        }
      }
    }
    .recipient_details{
      ${Input}{
      width:100%;
      border:none;
      border-bottom:1px solid rgba(34,36,38,.15);
      padding:.67857143em 0px;
      }
    }
    .price{
      span{
        color:red;
        font-weight:bold;
        font-size:30px;
      }
      strike{
        color:${(props) => props.theme.lightGray};
        margin:0px 20px;
        font-size:20px;
      }
      b{
        font-weight:normal;
      }
    }
    .quantity{

    }
    table{
      width:100%;
      text-align:left;
      border-spacing: 0;
      td{
        border:${(props) => props.theme.lightGray} solid 1px;
        padding:10px;
      }
      th{
        padding:10px;
      }
    }
    .delivery{
      ${Button}{
        width:100%;
        margin:20px 0px;
        font-weight:normal;
      }
    }
    .free_del{
      font-weight:bold;
      text-align:center;
      padding-top:20px;
      a{
        text-decoration:none;
        color: #78b8f8;
      }
    }
    .footer{
      padding:20px;
      margin:20px 0px;
      text-align:center;
    }
    .bottom{
      position: absolute;
      bottom: -30px;
      left: 20%;
      font-size: 13px;
      @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
        bottom: 20px;
        left: 15%;
      };
      a{
        color: #76b5f1;
        text-decoration: none;
      }
    }
    .pointer-none {
      pointer-events: none;
    }
`;

export default StyledBooking;



// WEBPACK FOOTER //
// client/containers/GiftCardProduct/StyledBooking.js